import { Injectable } from '@angular/core';
import { CountryCode, parsePhoneNumber, PhoneNumber } from 'libphonenumber-js';

@Injectable({providedIn: 'root'})
export class TelService {
  private shortestPhoneDigits = 4;

  format(phone: string, countryAbbr?: string, format = ''): string {
    const country: CountryCode =
      countryAbbr === 'UK' ? 'GB' : (countryAbbr as CountryCode);

    if (
      typeof phone !== 'string' ||
      phone.trim() === '' ||
      phone.length < this.shortestPhoneDigits
    ) {
      return phone;
    }

    try {
      if (country && format === 'intl') {
        return this.formatE164(phone, country);
      }
      //we need this case for waitlist and reservations pages
      if (country && format === 'custom') {
        return this.formatCustom(phone, country);
      }

      if (phone.charAt(0) === '+') {
        return this.formatInternational(phone);
      }

      if (phone.charAt(0) !== '+') {
        return this.formatNational(phone, country);
      }

      return phone;
    } catch(error) {
      return phone;
    }
  }

  formatNational(phone: string, country: CountryCode) {
    const parsedPhone: PhoneNumber = parsePhoneNumber(phone, country);
    if (parsedPhone?.number && parsedPhone?.country) {
      return parsedPhone.formatNational();
    }
    throw new Error('number or country is missing');
  }

  formatInternational(phone: string) {
    const parsedPhone: PhoneNumber = parsePhoneNumber(phone);
    if (parsedPhone?.number && parsedPhone?.country) {
        return parsedPhone.formatInternational();
    }
    throw new Error('number or country is missing');
  }

  formatE164(phone: string, country: CountryCode) {
    return parsePhoneNumber(phone, country).format('E.164');
  }

  formatCustom(phone: string, country: CountryCode) {
    const parsedPhone: PhoneNumber = parsePhoneNumber(phone);
    if (parsedPhone?.country === country && parsedPhone?.country) {
      return this.formatNational(phone, country);
    }

    return this.formatInternational(phone);
  }
}

